const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="gencrm_app__footer">
      <div className="gencrm_app__footer-content">
        <div className="gencrm_app__footer-copyright">
          &copy; {year} Generis Farmaceutica. Todos os direitos reservados.
        </div>
        <div className="gencrm_app__footer-powered">
          <img src="/logo.svg" alt="GenApps" className="gencrm_app__footer-logo" />
          <strong><em>Powered By GenApps</em></strong>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
